import * as _ from "lodash-es";
import {FCWithHTMLAttributes} from "../../../../../types/reactTypes";
import clsMerge from "../../../../../util/clsMerge";
import {CampusSelectorProps} from "./CampusSelector";
import {DayOfWeekDropdownProps} from "./DayOfWeekDropdown";
import groupCampusesByRegion from "../../../../../util/groupCampusesByRegion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/pro-regular-svg-icons/faLocationDot";

interface MobileCampusSelectorProps
	extends Omit<CampusSelectorProps, "setCurrentCampuses"> {
	onCampusSelected: (campusId: string) => void;
}

export interface MobileDuoFilterModalProps
	extends MobileCampusSelectorProps,
		DayOfWeekDropdownProps {
	onCampusSelected: (campusId: string) => void;
}

interface MobileFilterButtonProps {
	isSelected: boolean;
	onClick: () => void;
}

const SectionHeader: FCWithHTMLAttributes = ({children}) => (
	<div className="text-xs uppercase text-gray-700">{children}</div>
);

const MobileFilterButton: FCWithHTMLAttributes<MobileFilterButtonProps> = ({
	isSelected,
	onClick,
	children,
	className,
}) => {
	return (
		<button
			className={clsMerge(
				"w-auto rounded-full border-1 px-6 py-3 last:mr-0",
				isSelected
					? "border-transparent bg-gray-900 text-white hover:bg-gray-800"
					: "border-gray-400 bg-gray-50 text-gray-900 hover:bg-gray-200",
				className
			)}
			onClick={onClick}
		>
			{children}
		</button>
	);
};

const MobileCampusSelector: React.FC<MobileCampusSelectorProps> = ({
	onCampusSelected,
	currentCampuses,
	allCampusesById,
}) => {
	const campusesByRegion = groupCampusesByRegion(allCampusesById);
	return (
		<>
			<SectionHeader>Location</SectionHeader>
			{_.map(campusesByRegion, (campusesForRegion, region) => (
				<div key={region} className="flex flex-col gap-4">
					<div className="flex items-center gap-2">
						<div className="h-1px grow bg-gray-600" />
						<div className="font-overline text-gray-600">{region}</div>
					</div>
					<div className="flex flex-wrap gap-x-2 gap-y-4">
						{campusesForRegion.map(({campusId, city, stateAbbreviation}) => (
							<MobileFilterButton
								key={campusId}
								className="inline-flex items-center gap-2"
								onClick={() => onCampusSelected(campusId)}
								isSelected={currentCampuses.has(campusId)}
							>
								<FontAwesomeIcon icon={faLocationDot} />
								<span>
									{city}, {stateAbbreviation}
								</span>
							</MobileFilterButton>
						))}
					</div>
				</div>
			))}
		</>
	);
};

/**
 * This component is named MobileDuoFilterModal because it used to also contain
 * a day of the week selector. See commit 0248a44dfc8683eee1f65bae8f83295435c03c4a
 * if we ever want to add that back.
 */
const MobileDuoFilterModal: React.FC<MobileDuoFilterModalProps> = (props) => {
	return (
		<div className="flex max-w-full flex-col gap-6 overflow-x-visible px-duo-padx">
			<div className="flex items-center gap-4">
				<h2>AoPS Academy Campuses</h2>
			</div>
			<MobileCampusSelector {...props} />
		</div>
	);
};

export default MobileDuoFilterModal;
